import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from '../../util/PropTypes';
import Col from '../Col';
import DatoImage from '../DatoImage';
import Row from '../Row';

const ImageRow = ({ image1, image2, image3 }) => (
    <Row cols={{ xs: 2, sm: 2, md: 2, lg: 4 }} noGap>
        <Col md={2} className="hidden lg:block">
            <DatoImage
                image={image1}
                className="h-72"
            />
        </Col>
        <Col xs={2} md={1}>
            <DatoImage
                image={image2}
                className="h-72"
            />
        </Col>
        <Col className="hidden md:block">
            <DatoImage
                image={image3}
                className="h-72"
            />
        </Col>
    </Row>
);

ImageRow.getBlockClassnames = () => 'remove-bottom remove-top';

ImageRow.propTypes = {
    image1: PropTypes.datoImage,
    image2: PropTypes.datoImage,
    image3: PropTypes.datoImage,
};

ImageRow.defaultProps = {
    image1: null,
    image2: null,
    image3: null,
};

export const query = graphql`
    fragment ImageRowProps on DatoCmsImageRow {
        originalId
        image1 {
            gatsbyImageData(imgixParams: { auto: "format" })
            alt
            url
            smartTags
            focalPoint {
                x
                y
            }
        }
        image2 {
            gatsbyImageData(imgixParams: { auto: "format" })
            alt
            url
            smartTags
            focalPoint {
                x
                y
            }
        }
        image3 {
            gatsbyImageData(imgixParams: { auto: "format" })
            alt
            url
            smartTags
            focalPoint {
                x
                y
            }
        }
    }
`;

export default ImageRow;
